import { render, staticRenderFns } from "./Criterion.vue?vue&type=template&id=1e5a6625&scoped=true&"
import script from "./Criterion.vue?vue&type=script&lang=js&"
export * from "./Criterion.vue?vue&type=script&lang=js&"
import style0 from "./Criterion.vue?vue&type=style&index=0&id=1e5a6625&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5a6625",
  null
  
)

export default component.exports